import { Alert } from '../types/Alert'

export const groupByProductId = (alerts: Alert[]): Alert[][] =>
  Object.values(
    alerts.reduce(
      (productGroupings: { [productId: string]: Alert[] }, alert) => {
        if (productGroupings[alert.productId] === undefined) {
          productGroupings[alert.productId] = []
        }
        productGroupings[alert.productId].push(alert)
        return productGroupings
      },
      {},
    ),
  )

const IGNORE_ITEMBP_REGEX = /^ItemBp APEX ID \S*/
const reasonExtractor = (reason: string): string =>
  reason.replace(IGNORE_ITEMBP_REGEX, '')

interface MessagesGroupedByFieldId {
  [fieldId: string]: AlertsGroupedByMessage
}

interface AlertsGroupedByMessage {
  [message: string]: Alert[]
}

export const groupByFieldIdAndMessage = (alerts: Alert[]): Alert[][] =>
  Object.values(
    alerts.reduce((alertGroupings: MessagesGroupedByFieldId, alert) => {
      const message = reasonExtractor(alert.message)
      if (alertGroupings[alert.fieldId] === undefined) {
        alertGroupings[alert.fieldId] = {}
      }

      if (alertGroupings[alert.fieldId][message] === undefined) {
        alertGroupings[alert.fieldId][message] = []
      }

      alertGroupings[alert.fieldId][message].push(alert)
      return alertGroupings
    }, {}),
  ).flatMap(messageGrouping => Object.values(messageGrouping))
